module.exports = __webpack_public_path__ + "static/media/menu-icon-closed.3d3d10c4.svg";